/**
 * Route for `creative-max-50mb-upload`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CreativeMax50mbUploadPage } from "../features/creative-max-50mb-upload/CreativeMax50mbUploadPage";

export const creativeMax50mbUploadRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/creative-max-50mb-upload",
	component: CreativeMax50mbUploadPage,
});

export default creativeMax50mbUploadRoute;
